import axios from 'axios'
import { Toast } from 'vant'
import Vue from 'vue'

Vue.use(Toast)
// create an axios instance
const service = axios.create({
    baseURL: process.env.API_ROOT,
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(response => {
    const res = response.data
    // if (res.code!==200) {
    //     return Promise.reject(new Error(res.msg || 'Error'))
    // }
    return res
}, error => {
    console.log('服务异常', error) // for debug
    return Promise.reject(error)
})


export default service



// WEBPACK FOOTER //
// ./src/untils/service.js